/*
Version 0.115

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2021
	20-01-2021
	- [BORN] This class is born. Hooray!

!Usage
	specific_mobilemenu.onready();

	
!Wishlist

	none
	
*/
  
var specific_project = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	
	this.onready = function() {

		/*
		Listener
		*/
		$(document).on('click','.js-project-submit',function() {
			specific_project.save();
		});

		$(document).on('click','.js-project-active-submit',function() {
			specific_project.saveActive();
		});
	
	};
	 
	// METHODS  *****************************************************************
	// METHODS *****************************************************************
	// METHODS ******************************************************************
	// METHODS ******************************************************************

	/*
	Save *************************
	Save *************************
	Save *************************
	Save *************************
	*/
	this.save = function(
	) {

		var _project_id 		= $('.js-project-id').val();

		var _project_number 	= $('.js-projectnumber').val();
		var _project_client 	= $('.js-client_id').val();
		var _project_advisor 	= $('.js-advisor_id').val();
		var _project_meter 		= $('.js-meter_id').val();
		var _project_mechanic 	= $('.js-mechanic_id').val();

		/*
		Ajax
		*/
		$.ajax({
			url: globalUrl + '/a/a/project-action',
			type: "POST",
			data: {
				project_id 			: _project_id,
				project_number		: _project_number,
				project_client		: _project_client,
				project_advisor		: _project_advisor,
				project_meter 		: _project_meter,
				project_mechanic 	: _project_mechanic
			},
			headers: { 
				'go-load':1 
			}
		})
		.done(function(data) {

			/*
			Get: List
			*/
			specific_overview.getList(
				'list',
				'projects'
			);

			/*
			Close popup
			*/
			popup.close();

		})
		.always(function() {
		});

	};

	/*
	Save active *************************
	Save active *************************
	Save active *************************
	Save active *************************
	*/
	this.saveActive = function(
	) {

		var _project_id 		= $('.js-project-id').val();
		var _project_active 	= $('.js-project_status').val();
		var _project_overview 	= $('.js-project-overview').val();

		/*
		Ajax
		*/
		$.ajax({
			url: globalUrl + '/a/a/project-active-action',
			type: "POST",
			data: {
				project_id 			: _project_id,
				project_status 		: _project_active
			},
			headers: { 
				'go-load':1 
			}
		})
		.done(function(data) {

			if(_project_overview == 'active') {
				
				/*
				Get: List
				*/
				specific_overview.getList(
					'list',
					'projects'
				);

			} 

			if(_project_overview == 'archived') {
				setTimeout(function() {
					$('.js-nav-item-projecten').trigger('click');
				},500);
			} 

			/*
			Close popup
			*/
			popup.close();

		})
		.always(function() {
		});

	};
		
}).apply(specific_project); 